import { useMatches } from "react-router";
import type { RootLoaderType } from "~/root";

export const useUser = () => {
  const matches = useMatches();

  const data = (matches.find((route) => {
    return route.id === "root";
  })?.data || {}) as RootLoaderType;

  if (data) {
    return { user: data.user, authenticated: data.authenticated }
  }

  return { user: null, authenticated: false };
};
